import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';


@Injectable({
  providedIn: 'root'
})
export class AuditDashboard {  

  // O3CoreApiUrl = environment.O3CoreApiUrl;
  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }
  constructor(private http: HttpClient) { }

  get5sCompletion(data: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'AdminDashboard/get5scompletion', data);
  }

  Get5sOpen(data: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'AdminDashboard/get5sopen', data);
  }

  NoOf5sFindingOverall(data: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'AdminDashboard/noOf5sFindingOverall', data);
  }

  NoOf5sFindingByArea(data: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'AdminDashboard/noOf5sFindingByArea', data);
  }

  HeatMapData(data: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'AdminDashboard/heatmapdata', data);
  }

  GetAllExportData(data: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'AdminDashboard/GetAllExportData', data);
  }
}
